import {call, put,takeLatest} from 'redux-saga/effects';
import * as cartService from "../../../services/cartService"
import {
    EMPTY_CART,
    EMPTY_CART_SUCCESS,
    EMPTY_CART_ERROR
}
    from "../../actions/cart";

function* emptyCartaga(action) {
    try {
        const data=yield call(cartService.EmptyCart,action.payload)

        yield put({
            type: EMPTY_CART_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: EMPTY_CART_ERROR,error: error.data
        });
    }
}

export function* emptyCartSagaWatcher() {
    yield takeLatest(EMPTY_CART,emptyCartaga);
}